export default {
  merchantServiceOfferings(currentState, value) {
    const state = currentState;
    state.merchantServiceOfferings = value;
  },

};
